// src/router.js
// Tiny History-API router. Paths are app-relative ("/", "/blog") and are
// mapped onto Vite's BASE_URL when written to the address bar.
import { useEffect, useState } from "react";

const BASE = import.meta.env.BASE_URL || "/";

// "/resume/" -> "/resume", "/" -> ""
const BASE_PREFIX = BASE.endsWith("/") ? BASE.slice(0, -1) : BASE;

/** Browser pathname -> app-relative path. */
export function toRoute(pathname) {
  let p = pathname || "/";
  if (BASE_PREFIX && p.startsWith(BASE_PREFIX)) p = p.slice(BASE_PREFIX.length);
  if (!p.startsWith("/")) p = `/${p}`;
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p;
}

/** App-relative path -> href usable in <a href> / pushState. */
export function toHref(route) {
  return `${BASE_PREFIX}${route}` || "/";
}

export function navigate(route, { replace = false } = {}) {
  const href = toHref(route);
  if (replace) window.history.replaceState({}, "", href);
  else window.history.pushState({}, "", href);
  // pushState/replaceState don't emit popstate, so announce it ourselves.
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function useRoute() {
  const [route, setRoute] = useState(() => toRoute(window.location.pathname));

  useEffect(() => {
    const sync = () => setRoute(toRoute(window.location.pathname));
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  return route;
}
